import { ChevronDownIcon } from "@heroicons/react/20/solid";
import { GroupBase, StylesConfig } from "react-select";

export const PRIMARY_COLOR = "#79c4b7";

export const PRIMARY_DARK = "#00728f";

export const PRIMARY_HOVER = "#429587";

export const REACT_SELECT_STYLES: StylesConfig<any, true, GroupBase<any>> = {
  control: (baseStyles) => ({
    ...baseStyles,
    // borderColor: state.isFocused ? 'grey' : 'red',
    borderColor: PRIMARY_COLOR,
    outlineColor: PRIMARY_COLOR,
    borderRadius: "0.375rem",
  }),
  indicatorSeparator: (baseStyles) => ({
    ...baseStyles,
    // borderColor: state.isFocused ? 'grey' : 'red',
    backgroundColor: PRIMARY_COLOR,
  }),
  option: (baseStyles, state) => ({
    ...baseStyles,
    backgroundColor: state.isFocused ? PRIMARY_COLOR : "",
  }),
  multiValue: (baseStyles) => ({
    ...baseStyles,
    backgroundColor: PRIMARY_COLOR,
  }),
  multiValueLabel: (baseStyles) => ({
    ...baseStyles,
    color: "white",
  }),
  multiValueRemove: (baseStyles) => ({
    ...baseStyles,
    color: "white",
    backgroundColor: PRIMARY_COLOR, // Change this to your desired color
    ":hover": {
      backgroundColor: PRIMARY_HOVER, // Change this to your desired hover color
    },
  }),
  placeholder: (provided) => ({
    ...provided,
    color: "#999",
    whiteSpace: "nowrap",
    // color: PRIMARY_COLOR // Change this to your desired color
  }),
};

export const DropdownIndicator = () => (
  <ChevronDownIcon className="text-primary w-5 h-5 m-1" />
);
